import type { OverallStatus } from '../lib/types';

interface Copy {
  title: string;
  subtitle: string;
  bg: string;
}

const COPY: Record<OverallStatus, Copy> = {
  operational: {
    title: 'All Systems Operational',
    subtitle: 'All services are running normally.',
    bg: 'bg-status-operational-banner',
  },
  maintenance: {
    title: 'Scheduled Maintenance',
    subtitle: 'Maintenance is currently in progress.',
    bg: 'bg-status-maintenance',
  },
  degraded: {
    title: 'Minor Service Disruption',
    subtitle: 'Some services are operating with reduced performance.',
    bg: 'bg-status-degraded',
  },
  partial_outage: {
    title: 'Partial Service Outage',
    subtitle: 'Some services are unavailable for some users.',
    bg: 'bg-status-partial',
  },
  major_outage: {
    title: 'Major Service Outage',
    subtitle: 'Multiple services are unavailable.',
    bg: 'bg-status-major',
  },
};

interface Props {
  status: OverallStatus;
}

export function StatusBanner({ status }: Readonly<Props>) {
  const c = COPY[status];
  return (
    <div
      className={`${c.bg} px-5 py-4 text-white`}
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="font-display text-lg font-medium tracking-tight">{c.title}</div>
          <div className="mt-0.5 text-sm opacity-90">{c.subtitle}</div>
        </div>
        {status === 'operational' && (
          <div className="font-mono text-xs uppercase tracking-wider opacity-90">Live</div>
        )}
      </div>
    </div>
  );
}
